import { useMemo } from 'react';

import './index.css';
import { TimeFrame } from '../../../../../types/Bot';
import DropdownComponent from '../../../../../components/Form/Dropdown';
import { colors } from '../../../../../colors';

interface Props {
  higherTimeFrame: TimeFrame;
  setHigherTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
  shorterTimeFrame: TimeFrame;
  setShorterTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
  multiOrderTimeFrame: TimeFrame;
  setMultiOrderTimeFrame: React.Dispatch<React.SetStateAction<TimeFrame>>;
}

const TimesFramesForm = (props: Props) => {
  const {
    higherTimeFrame,
    setHigherTimeFrame,
    shorterTimeFrame,
    setShorterTimeFrame,
    multiOrderTimeFrame,
    setMultiOrderTimeFrame,
  } = props;

  const timeFrames = useMemo(() => Object.values(TimeFrame), []);

  return (
    <div>
      <p
        style={{
          fontWeight: 'bold',
          color: colors.white,
          marginLeft: 50,
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        Time Frames
      </p>

      <div
        style={{
          display: 'flex',
          marginLeft: 50,
          columnGap: 16,
        }}
      >
        <DropdownComponent
          config={{
            label: 'Higher TimeFrame',
            value: higherTimeFrame,
            handleValueChange: setHigherTimeFrame,
            options: timeFrames,
          }}
        />
        <DropdownComponent
          config={{
            label: 'Shorter TimeFrame',
            value: shorterTimeFrame,
            handleValueChange: setShorterTimeFrame,
            options: timeFrames,
          }}
        />
        <DropdownComponent
          config={{
            label: 'Multi TimeFrame',
            value: multiOrderTimeFrame,
            handleValueChange: setMultiOrderTimeFrame,
            options: timeFrames,
          }}
        />
      </div>
    </div>
  );
};

export default TimesFramesForm;
